// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.z-10 {
  z-index: 10;
}
.m-0 {
  margin: 0px;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.size-11 {
  width: 2.75rem;
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-5 {
  height: 1.25rem;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-full {
  height: 100%;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.columns-3 {
  columns: 3;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.appointment-popup {
  border: 1px solid #6340fb;
  border-radius: 7px;
}

@media screen and (max-width: 768px) {
  .appointment-popup {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    top: 0;
    border-radius: 0;
    overflow: auto;
    height: calc(100% - 6.4rem);
    min-height: auto;
    max-height: 100%;
  }
}
.appointment-popup .appointment-user-wrapper {
  background: #2c3153;
  flex: 0 0 25rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper {
    flex-wrap: wrap;
    display: flex;
    width: 100%;
  }
}
.appointment-popup .appointment-user-wrapper .user-avatar {
  position: relative;
  padding-bottom: 100%;
  width: 100%;
  overflow: hidden;
}

.appointment-popup .appointment-user-wrapper .user-avatar img {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .user-avatar {
    flex: 0 0 35%;
    padding-bottom: 35%;
  }
}
.appointment-popup .appointment-user-wrapper .appointment-user {
  padding: 2rem 2rem 0 2rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .appointment-user {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    padding: 2rem;
    flex-direction: column;
  }
}
.appointment-popup .appointment-user-wrapper .appointment-user .username {
  color: white;
  font-size: 1.8rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .specialization {
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.3rem;
  display: block;
  margin-top: 0.5rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation {
  display: flex;
  margin-top: 0.5rem;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation span {
  padding: 0.25rem !important;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation span:before {
  content: "\\f005";
  font-family: "Font Awesome 5 Pro";
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
  display: block;
}

.appointment-popup .appointment-user-wrapper .appointment-user .notation.five span:nth-child(-n+5):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.four span:nth-child(-n+4):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.three span:nth-child(-n+3):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.two span:nth-child(-n+2):before,
.appointment-popup .appointment-user-wrapper .appointment-user .notation.one span:nth-child(-n+1):before {
  color: #ee5181;
}

.appointment-popup .appointment-user-wrapper .appointment-location {
  padding: 2rem 0;
  margin: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}

.appointment-popup .appointment-user-wrapper .appointment-location p {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 0;
  margin-bottom: 0.5rem;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-user-wrapper .appointment-location {
    width: 100%;
    margin: 0;
  }
}
.appointment-popup .appointment-calendar {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  /* padding: 10px 8px; */
  /* left: 50%; */
  /* max-width: 90%; */
  background: white;
  border-radius: 8px;
  z-index: 1;
  /* transform: translateX(-50%);*/
}

.appointment-popup .appointment-calendar .calendar-nav {
  right: 0;
  position: absolute;
  margin-top: 0;
}

.current-week {
  /*mat-icon {
      font-size: 20px;
  }*/
  /*.calendar-nav {
      mat-icon {
          font-size: 18px;
      }
  }*/
}

.appointment-popup .appointment-calendar .current-week {
  display: flex;
  /*justify-content: space-between;*/
  padding: 8px 0;
  border-bottom: 1px solid #f3f3f3;
  align-items: center;
  width: auto;
  justify-content: space-between;
}

.appointment-popup .appointment-calendar .current-week > span {
  font-size: 16px;
  color: #5a5a5a;
  padding-left: 25px;
  line-height: 40px;
  clear: both;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.appointment-popup .appointment-calendar .current-week > span i {
  color: #333333;
  margin-right: 0.5rem;
  opacity: 0.7;
  width: 20px;
  text-align: center;
}

.appointment-popup .appointment-calendar .current-week .calendar-nav button {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 0;
  cursor: pointer;
  outline: none;
  color: #515151;
  width: 50px;
}

.appointment-popup .appointment-calendar .current-week .calendar-nav button:before {
  font-family: "Font Awesome 5 Pro";
  font-size: 2rem;
  padding: 0 1.5rem;
  display: block;
}

@media screen and (max-width: 768px) {
  .appointment-popup .appointment-calendar .current-week .calendar-nav {
    flex-wrap: wrap;
  }
  .appointment-popup .appointment-calendar .current-week .calendar-nav .calendar-nav button:before {
    padding: 0 1rem;
    font-size: 1.2rem;
  }
  .appointment-popup .appointment-calendar .current-week .calendar-nav > span {
    font-size: 1.5rem;
  }
}
.appointment-popup .appointment-calendar .calendar-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week {
  border-bottom: 2px solid #158ec6;
  background-color: #353a48;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul {
  padding: 0;
  list-style: none;
  display: flex;
  width: 100%;
  margin: 0;
  height: 55px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul li {
  width: 100%;
  font-weight: 600;
  padding: 0.25rem 0;
  text-align: center;
  color: #d6d6d6;
  background-size: 100% 100%;
  background: rgb(84, 84, 84);
  background: linear-gradient(3deg, rgb(84, 84, 84) 0%, rgb(68, 68, 68) 100%);
  border-color: #333333;
  box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours {
  overflow: auto;
  height: 290px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours ul {
  list-style: none;
  padding: 0;
  margin: 0;
  padding: 5px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li {
  width: 100%;
  text-align: center;
  padding-top: 8px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  /* min-height: 0.7rem; */
  cursor: pointer;
  background: #11b3a4;
  border-radius: 3px;
  color: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  margin-bottom: 6px;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty {
  background: none;
  box-shadow: none;
}

.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty:hover {
  background: none;
  box-shadow: none;
}

.calendar-hours::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.calendar-hours::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}

.calendar-hours::-webkit-scrollbar-thumb {
  background: #158ec6;
  border: 0px none #ffffff;
  border-radius: 12px;
}
.calendar-hours::-webkit-scrollbar-thumb:hover {
  background: #919191;
}
.calendar-hours::-webkit-scrollbar-thumb:active {
  background: #158ec6;
}

.calendar-hours::-webkit-scrollbar-track {
  background: #666666;
  border: 0px none #ffffff;
  border-bottom-right-radius: 6px;
}
.calendar-hours::-webkit-scrollbar-track:hover {
  background: #666666;
}
.calendar-hours::-webkit-scrollbar-track:active {
  background: #888888;
}

.calendar-hours::-webkit-scrollbar-corner {
  background: transparent;
}

.message-not-available-planning {
  height: 100px;
}

.btn-select-type {
  background: transparent !important;
}

.selected-type {
  background: #11b3a4 !important;
  color: white !important;
}

.select-lieux-consultation {
  background: #11b3a4;
}

.select-motif {
  background: #11b3a4;
}

.li-slot:not(:last-child):not(:first-child) {
  border-left: 0.5px solid #eaeaec;
  border-right: 0.5px solid #eaeaec;
}

.li-slot:first-child {
  border-right: 0.5px solid #eaeaec;
}

.li-slot:last-child {
  border-left: 0.5px solid #eaeaec;
}

.top-header-planning {
  border-bottom: 2px solid #158ec6;
  background-color: #353a48;
}

.calendar-wrapper-header {
  background: transparent;
}
.calendar-wrapper-header :hover {
  background: #158ec6;
  border-radius: 0.5rem;
}
.calendar-wrapper-header.now {
  background: #11b3a4;
}
.calendar-wrapper-header.now :hover {
  background: #0e9789;
  border-radius: 0.5rem;
}

.mat-mdc-fab, .mat-mdc-mini-fab {
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 1px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
}

.emergency {
  background-color: orange !important;
}

.locked_day {
  background-color: #353a48 !important;
}

.selected {
  background-color: #158ec6 !important;
}

.step-circle {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
}

.step-circle.active {
  background-color: #0d6efd;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.header-bg {
  background-color: #3b82f6; /* Blue header background */
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
}

.rounded-button {
  border: 2px solid #3b82f6;
  border-radius: 10px;
  font-weight: bold;
  transition: all 0.3s;
}

.rounded-button:hover {
  background-color: #3b82f6;
  color: white;
}

.step-indicator .step-circle {
  width: 40px;
  height: 40px;
  background-color: #e0e0e0;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: bold;
}

.step-indicator .step-circle.active {
  background-color: #3b82f6;
}

.step-circle {
  width: 40px; /* Circle width */
  height: 40px; /* Circle height */
  border-radius: 50%; /* Make circles */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold; /* Text style */
}

.line {
  position: absolute;
  top: 50%;
  left: 100%; /* Start line after circle */
  height: 2px; /* Line thickness */
  background-color: #ccc; /* Line color */
  width: 100%; /* Full width */
  z-index: -1; /* Ensure lines are behind the circles */
}

.step:last-child .line {
  display: none; /* Hide the last line */
}

.selectedReason, .selectedPractice {
  color: white;
  font-weight: bold;
  background-color: #3b82f6;
}

::ng-deep .mat-step-header {
  pointer-events: none; /* Prevents clicking on the header */
}

.booking-summary {
  width: 450px;
  margin: auto;
}

.booking-summary .title-col h5 {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 12px;
}

.summary-col {
  width: 100%;
}
.summary-col mat-card {
  border-radius: 4px;
  font-weight: 700;
}

.summary-col + .summary-col {
  padding-top: 16px;
}

.summary-col-inner {
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.0784313725);
  display: inline-block;
  width: 100%;
  padding: 15px;
}

.summary-col-inner > div + div {
  padding-top: 10px;
}

.summary-col-inner span {
  float: right;
  color: #858585;
}

::ng-deep .app.blue .mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field .mdc-notched-outline__notch {
  border-right: 1px solid transparent !important;
}

::ng-deep .mat-mdc-floating-label {
  font-family: "Montserrat";
}

::ng-deep .mat-mdc-unelevated-button > .mat-icon,
::ng-deep .mat-mdc-raised-button > .mat-icon,
::ng-deep .mat-mdc-outlined-button > .mat-icon {
  margin: 0 !important;
}

::ng-deep .mat-horizontal-content-container {
  padding: 0 !important;
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

@media (min-width: 768px) {

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:block {
    display: block;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }
}

@media (prefers-color-scheme: dark) {

  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }

  .dark\\:bg-gray-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }

  .dark\\:bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }

  .dark\\:text-gray-200 {
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-600:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
  }

  .dark\\:hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/apps/planning-multipractices/planning.component.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qBAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA,WAAA;AAAA;AAAA;;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,gBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AAAA;;EAAA;IAAA,iBAAA;EAAA;AAAA;AACA;EAAA,oBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,4BAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,cAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;;EAAA;IAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,UAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,2BAAA;AAAA;AAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,8BAAA;AAAA;AAAA;EAAA,6BAAA;AAAA;AAAA;EAAA,WAAA;AAAA;AAAA;EAAA,SAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA,uDAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,cAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,wBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sDAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,2DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,4DAAA;AAAA;AAAA;EAAA,YAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,aAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,uBAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,qBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,kBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,eAAA;AAAA;AAAA;EAAA,sBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,eAAA;EAAA,mBAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,gBAAA;AAAA;AAAA;EAAA,yBAAA;AAAA;AAAA;EAAA,iBAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,kDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,gDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,mDAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,iDAAA;AAAA;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA,uGAAA;AAAA;AAAA;EAAA,oBAAA;AAAA;AAAA;EAAA,iLAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA,0BAAA;AAAA;AAAA;EAAA,0BAAA;AAAA;AAEA;EACE,yBAAA;EACA,kBAAA;AAAF;;AAEA;EACI;IACI,sBAAA;IACA,WAAA;IACA,eAAA;IACA,MAAA;IACA,gBAAA;IACA,cAAA;IACA,2BAAA;IACA,gBAAA;IACA,gBAAA;EACN;AACF;AACA;EACI,mBAAA;EACA,eAAA;AACJ;;AACA;EACI;IACI,eAAA;IACA,aAAA;IACA,WAAA;EAEN;AACF;AAAA;EACI,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAKA,gCAAA;AAGJ;;AADA;EACI;IACI,aAAA;IACA,mBAAA;EAIN;AACF;AAFA;EACI,yBAAA;AAIJ;;AAFA;EACI;IACI,OAAA;IACA,aAAA;IACA,uBAAA;IACA,uBAAA;IACA,eAAA;IACA,aAAA;IACA,sBAAA;EAKN;AACF;AAHA;EACI,YAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,+BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAMJ;;AAJA;EACI,aAAA;EACA,kBAAA;AAOJ;;AALA;EACI,2BAAA;AAQJ;;AANA;EACI,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;AASJ;;AAPA;;;;;EAKI,cAAA;AAUJ;;AARA;EACI,eAAA;EACA,YAAA;EACA,8CAAA;AAWJ;;AATA;EACI,+BAAA;EACA,aAAA;EACA,qBAAA;AAYJ;;AAVA;EACI;IACI,WAAA;IACA,SAAA;EAaN;AACF;AAVA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AAWJ;;AATA;EACI,QAAA;EACA,kBAAA;EACA,aAAA;AAYJ;;AATA;EAEI;;IAAA;EAGA;;;;IAAA;AAeJ;;AAPA;EACI,aAAA;EACA,kCAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAUJ;;AARA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAWJ;;AATA;EACI,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAYJ;;AAVA;EACI,YAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AAaJ;;AAXA;EACI,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAcJ;;AAXA;EACI;IACI,eAAA;EAcN;EAZE;IACI,eAAA;IACA,iBAAA;EAcN;EAZE;IACI,iBAAA;EAcN;AACF;AAZA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAcJ;;AAZA;EACI,gCAAA;EACA,yBAAA;AAeJ;;AAbA;EACI,UAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAgBJ;;AAdA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAIA,0BAAA;EACA,2BAAA;EACA,2EAAA;EAGA,qBAAA;EACA,gFAAA;EACA,wFAAA;EACA,qFAAA;AAeJ;;AAbA;EACI,cAAA;EACA,aAAA;AAgBJ;;AAdA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAiBJ;;AAfA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;AAkBJ;;AAhBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;AAmBJ;;AAhBA;EACI,gBAAA;EACA,gBAAA;AAmBJ;;AAjBA;EACI,gBAAA;EACA,gBAAA;AAoBJ;;AAZA;EACI,UAAA;EACA,WAAA;AAeJ;;AAbA;EACI,UAAA;EACA,WAAA;AAgBJ;;AAdA;EACI,mBAAA;EACA,wBAAA;EACA,mBAAA;AAiBJ;AAhBI;EACI,mBAAA;AAkBR;AAhBI;EACI,mBAAA;AAkBR;;AAfA;EACI,mBAAA;EACA,wBAAA;EACA,+BAAA;AAkBJ;AAjBI;EACI,mBAAA;AAmBR;AAjBI;EACI,mBAAA;AAmBR;;AAhBA;EACI,uBAAA;AAmBJ;;AAjBA;EACI,aAAA;AAoBJ;;AAlBA;EACI,kCAAA;AAqBJ;;AAnBA;EACI,8BAAA;EACA,uBAAA;AAsBJ;;AApBA;EACI,mBAAA;AAuBJ;;AArBA;EACI,mBAAA;AAwBJ;;AAtBA;EACI,gCAAA;EACA,iCAAA;AAyBJ;;AAtBA;EACI,iCAAA;AAyBJ;;AAtBA;EACI,gCAAA;AAyBJ;;AAvBA;EACI,gCAAA;EACA,yBAAA;AA0BJ;;AAxBA;EAEI,uBAAA;AA0BJ;AAzBI;EACI,mBAAA;EACA,qBAAA;AA2BR;AAzBI;EACI,mBAAA;AA2BR;AA1BQ;EACI,mBAAA;EACA,qBAAA;AA4BZ;;AAvBA;EACI,0HAAA;AA0BJ;;AAxBA;EACI,mCAAA;AA2BJ;;AAzBA;EACI,oCAAA;AA4BJ;;AA1BA;EACI,oCAAA;AA6BJ;;AA3BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AA8BF;;AA5BA;EACE,yBAAA;AA+BF;;AA7BA;EACE,eAAA;AAgCF;;AA9BA;EACE,yBAAA;AAiCF;;AA7BA;EACE,yBAAA,EAAA,2BAAA;EACA,YAAA;EACA,gCAAA;AAgCF;;AA9BA;EACE,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAiCF;;AA/BA;EACE,yBAAA;EACA,YAAA;AAkCF;;AAhCA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAmCF;;AAjCA;EACE,yBAAA;AAoCF;;AAjCA;EACE,WAAA,EAAA,iBAAA;EACA,YAAA,EAAA,kBAAA;EACA,kBAAA,EAAA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA,EAAA,eAAA;AAoCF;;AAjCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA,EAAA,4BAAA;EACA,WAAA,EAAA,mBAAA;EACA,sBAAA,EAAA,eAAA;EACA,WAAA,EAAA,eAAA;EACA,WAAA,EAAA,wCAAA;AAoCF;;AAjCA;EACE,aAAA,EAAA,uBAAA;AAoCF;;AAhCA;EACI,YAAA;EACA,iBAAA;EACA,yBAAA;AAmCJ;;AA9BA;EACE,oBAAA,EAAA,oCAAA;AAiCF;;AA7BA;EACE,YAAA;EACA,YAAA;AAgCF;;AA9BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAiCF;;AA/BA;EACE,WAAA;AAkCF;AAjCE;EACE,kBAAA;EACA,gBAAA;AAmCJ;;AAhCA;EACE,iBAAA;AAmCF;;AAjCA;EACE,mBAAA;EACA,sBAAA;EACA,oDAAA;EACA,qBAAA;EACA,WAAA;EACA,aAAA;AAoCF;;AAlCA;EACE,iBAAA;AAqCF;;AAnCA;EACE,YAAA;EACA,cAAA;AAsCF;;AApCA;EACE,8CAAA;AAuCF;;AApCA;EACE,yBAAA;AAuCF;;AArCA;;;EAGE,oBAAA;AAwCF;;AArCA;EACE,qBAAA;AAwCF;;AA5iBA;EAAA,kBA4iBA;EA5iBA,0DAAA;AA4iBA;;AA5iBA;EAAA,kBA4iBA;EA5iBA,4DAAA;AA4iBA;;AA5iBA;EAAA,kBA4iBA;EA5iBA,yDAAA;AA4iBA;;AA5iBA;EAAA,+BAAA;AA4iBA;;AA5iBA;EAAA,+EA4iBA;EA5iBA,mGA4iBA;EA5iBA,uGAAA;AA4iBA;;AA5iBA;EAAA,8BA4iBA;EA5iBA,mBAAA;AA4iBA;;AA5iBA;EAAA,2GA4iBA;EA5iBA,yGA4iBA;EA5iBA,4FAAA;AA4iBA;;AA5iBA;EAAA,oBA4iBA;EA5iBA,6DAAA;AA4iBA;;AA5iBA;;EAAA;IAAA,4BAAA;EA4iBA;;EA5iBA;IAAA,4BAAA;EA4iBA;;EA5iBA;IAAA,cAAA;EA4iBA;;EA5iBA;IAAA,aAAA;EA4iBA;;EA5iBA;IAAA,gDAAA;EA4iBA;;EA5iBA;IAAA,gDAAA;EA4iBA;;EA5iBA;IAAA,uBAAA;EA4iBA;;EA5iBA;IAAA,eAAA;EA4iBA;AAAA;;AA5iBA;;EAAA;IAAA,sBA4iBA;IA5iBA,yDAAA;EA4iBA;;EA5iBA;IAAA,kBA4iBA;IA5iBA,yDAAA;EA4iBA;;EA5iBA;IAAA,kBA4iBA;IA5iBA,yDAAA;EA4iBA;;EA5iBA;IAAA,oBA4iBA;IA5iBA,mDAAA;EA4iBA;;EA5iBA;IAAA,kBA4iBA;IA5iBA,yDAAA;EA4iBA;;EA5iBA;IAAA,kBA4iBA;IA5iBA,yDAAA;EA4iBA;;EA5iBA;IAAA,oBA4iBA;IA5iBA,mDAAA;EA4iBA;AAAA;AAkmCA,47/BAA47/B","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.appointment-popup {\n  border: 1px solid #6340fb;\n  border-radius: 7px;\n}\n@media screen and (max-width: 768px) {\n    .appointment-popup {\n        flex-direction: column;\n        width: 100%;\n        max-width: 100%;\n        top: 0;\n        border-radius: 0;\n        overflow: auto;\n        height: calc(100% - 6.4rem);\n        min-height: auto;\n        max-height: 100%;\n    }\n}\n.appointment-popup .appointment-user-wrapper {\n    background: #2c3153;\n    flex: 0 0 25rem;\n}\n@media screen and (max-width: 768px) {\n    .appointment-popup .appointment-user-wrapper {\n        flex-wrap: wrap;\n        display: flex;\n        width: 100%;\n    }\n}\n.appointment-popup .appointment-user-wrapper .user-avatar {\n    position: relative;\n    padding-bottom: 100%;\n    width: 100%;\n    overflow: hidden;\n}\n.appointment-popup .appointment-user-wrapper .user-avatar img {\n    height: 100%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n@media screen and (max-width: 768px) {\n    .appointment-popup .appointment-user-wrapper .user-avatar {\n        flex: 0 0 35%;\n        padding-bottom: 35%;\n    }\n}\n.appointment-popup .appointment-user-wrapper .appointment-user {\n    padding: 2rem 2rem 0 2rem;\n}\n@media screen and (max-width: 768px) {\n    .appointment-popup .appointment-user-wrapper .appointment-user {\n        flex: 1;\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n        flex-wrap: wrap;\n        padding: 2rem;\n        flex-direction: column;\n    }\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .username {\n    color: white;\n    font-size: 1.8rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .specialization {\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 1.3rem;\n    display: block;\n    margin-top: 0.5rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation {\n    display: flex;\n    margin-top: 0.5rem;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation span {\n    padding: 0.25rem !important;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation span:before {\n    content: \"\\f005\";\n    font-family: 'Font Awesome 5 Pro';\n    font-weight: bold;\n    color: rgba(255, 255, 255, 0.5);\n    display: block;\n}\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.five span:nth-child(-n+5):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.four span:nth-child(-n+4):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.three span:nth-child(-n+3):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.two span:nth-child(-n+2):before,\n.appointment-popup .appointment-user-wrapper .appointment-user .notation.one span:nth-child(-n+1):before {\n    color: #ee5181;\n}\n.appointment-popup .appointment-user-wrapper .appointment-location {\n    padding: 2rem 0;\n    margin: 2rem;\n    border-top: 1px solid rgba(255, 255, 255, 0.5);\n}\n.appointment-popup .appointment-user-wrapper .appointment-location p {\n    color: rgba(255, 255, 255, 0.5);\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\n@media screen and (max-width: 768px) {\n    .appointment-popup .appointment-user-wrapper .appointment-location {\n        width: 100%;\n        margin: 0;\n    }\n}\n\n.appointment-popup .appointment-calendar {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    //box-shadow: 0 0 4px rgb(0 0 0 / 20%);\n    position: relative;\n    /* padding: 10px 8px; */\n    /* left: 50%; */\n    /* max-width: 90%; */\n    background: white;\n    border-radius: 8px;\n    z-index: 1;\n    /* transform: translateX(-50%);*/\n}\n.appointment-popup .appointment-calendar .calendar-nav {\n    right: 0;\n    position: absolute;\n    margin-top: 0;\n}\n\n.current-week {\n\n    /*mat-icon {\n        font-size: 20px;\n    }*/\n    /*.calendar-nav {\n        mat-icon {\n            font-size: 18px;\n        }\n    }*/\n}\n\n\n.appointment-popup .appointment-calendar .current-week {\n    display: flex;\n    /*justify-content: space-between;*/\n    padding: 8px 0;\n    border-bottom: 1px solid #f3f3f3;\n    align-items: center;\n    width: auto;\n    justify-content: space-between;\n}\n.appointment-popup .appointment-calendar .current-week > span {\n    font-size: 16px;\n    color: #5a5a5a;\n    padding-left: 25px;\n    line-height: 40px;\n    clear: both;\n    display: inline-block;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.appointment-popup .appointment-calendar .current-week > span i {\n    color: #333333;\n    margin-right: 0.5rem;\n    opacity: 0.7;\n    width: 20px;\n    text-align: center;\n}\n.appointment-popup .appointment-calendar .current-week .calendar-nav button {\n    border: none;\n    background: transparent;\n    padding: 0;\n    font-size: 0;\n    cursor: pointer;\n    outline: none;\n    color: #515151;\n    width: 50px;\n}\n.appointment-popup .appointment-calendar .current-week .calendar-nav button:before {\n    font-family: \"Font Awesome 5 Pro\";\n    font-size: 2rem;\n    padding: 0 1.5rem;\n    display: block;\n}\n\n@media screen and (max-width: 768px) {\n    .appointment-popup .appointment-calendar .current-week .calendar-nav {\n        flex-wrap: wrap;\n    }\n    .appointment-popup .appointment-calendar .current-week .calendar-nav .calendar-nav button:before {\n        padding: 0 1rem;\n        font-size: 1.2rem;\n    }\n    .appointment-popup .appointment-calendar .current-week .calendar-nav > span {\n        font-size: 1.5rem;\n    }\n}\n.appointment-popup .appointment-calendar .calendar-wrapper {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week {\n    border-bottom: 2px solid #158ec6;\n    background-color: #353a48;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul {\n    padding: 0;\n    list-style: none;\n    display: flex;\n    width: 100%;\n    margin: 0;\n    height: 55px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-week ul li {\n    width: 100%;\n    font-weight: 600;\n    padding: 0.25rem 0;\n    text-align: center;\n    color: #d6d6d6;\n    -webkit-background-size: 100% 100%;\n    -moz-background-size: 100% 100%;\n    -o-background-size: 100% 100%;\n    background-size: 100% 100%;\n    background: rgb(84,84,84);\n    background: linear-gradient(3deg, rgba(84,84,84,1) 0%, rgba(68,68,68,1) 100%);\n\n\n    border-color: #333333;\n    box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n    -webkit-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n    -moz-box-shadow: inset 0 0 1px rgba(255, 255, 255, 0.75), 0 1px 0 rgba(0, 0, 0, 0.15);\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours {\n    overflow: auto;\n    height: 290px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    padding: 5px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li {\n    width: 100%;\n    text-align: center;\n    padding-top: 8px;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2px;\n    /* min-height: 0.7rem; */\n    cursor: pointer;\n    background: #11b3a4;\n    border-radius: 3px;\n    color: white;\n    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);\n    margin-bottom: 6px;\n}\n\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty {\n    background: none;\n    box-shadow: none;\n}\n.appointment-popup .appointment-calendar .calendar-wrapper .calendar-hours > ul > li > ul > li.empty:hover {\n    background: none;\n    box-shadow: none;\n}\n\n\n\n\n\n\n.calendar-hours::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n.calendar-hours::-webkit-scrollbar-button {\n    width: 0px;\n    height: 0px;\n}\n.calendar-hours::-webkit-scrollbar-thumb {\n    background: #158ec6;\n    border: 0px none #ffffff;\n    border-radius: 12px;\n    &:hover{\n        background: #919191;\n    }\n    &:active{\n        background: #158ec6;\n    }\n}\n.calendar-hours::-webkit-scrollbar-track {\n    background: #666666;\n    border: 0px none #ffffff;\n    border-bottom-right-radius: 6px;\n    &:hover{\n        background: #666666;\n    }\n    &:active{\n        background: #888888;\n    }\n}\n.calendar-hours::-webkit-scrollbar-corner {\n    background: transparent;\n}\n.message-not-available-planning{\n    height: 100px;\n}\n.btn-select-type{\n    background: transparent !important;\n}\n.selected-type{\n    background: #11b3a4 !important;\n    color: white !important;\n}\n.select-lieux-consultation{\n    background: #11b3a4;\n}\n.select-motif{\n    background: #11b3a4;\n}\n.li-slot:not(:last-child):not(:first-child) {\n    border-left: 0.5px solid #eaeaec;\n    border-right: 0.5px solid #eaeaec;\n}\n\n.li-slot:first-child {\n    border-right: 0.5px solid #eaeaec;\n}\n\n.li-slot:last-child {\n    border-left: 0.5px solid #eaeaec;\n}\n.top-header-planning{\n    border-bottom: 2px solid #158ec6;\n    background-color: #353a48;\n}\n.calendar-wrapper-header\n{\n    background: transparent;\n    :hover {\n        background: #158ec6;\n        border-radius: 0.5rem;\n    }\n    &.now{\n        background: #11b3a4;\n        :hover {\n            background: #0e9789;\n            border-radius: 0.5rem;\n        }\n    }\n}\n//Fix shadow of icons\n.mat-mdc-fab, .mat-mdc-mini-fab{\n    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 1px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)\n}\n.emergency {\n    background-color: orange !important;\n}\n.locked_day{\n    background-color: #353a48 !important;\n}\n.selected {\n    background-color: #158ec6 !important;\n}\n.step-circle {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 18px;\n  color: white;\n}\n.step-circle.active {\n  background-color: #0d6efd;\n}\n.list-group-item {\n  cursor: pointer;\n}\n.list-group-item:hover {\n  background-color: #f8f9fa;\n}\n\n\n.header-bg {\n  background-color: #3b82f6; /* Blue header background */\n  color: white;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.rounded-button {\n  border: 2px solid #3b82f6;\n  border-radius: 10px;\n  font-weight: bold;\n  transition: all 0.3s;\n}\n.rounded-button:hover {\n  background-color: #3b82f6;\n  color: white;\n}\n.step-indicator .step-circle {\n  width: 40px;\n  height: 40px;\n  background-color: #e0e0e0;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  font-weight: bold;\n}\n.step-indicator .step-circle.active {\n  background-color: #3b82f6;\n}\n\n.step-circle {\n  width: 40px; /* Circle width */\n  height: 40px; /* Circle height */\n  border-radius: 50%; /* Make circles */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold; /* Text style */\n}\n\n.line {\n  position: absolute;\n  top: 50%;\n  left: 100%; /* Start line after circle */\n  height: 2px; /* Line thickness */\n  background-color: #ccc; /* Line color */\n  width: 100%; /* Full width */\n  z-index: -1; /* Ensure lines are behind the circles */\n}\n\n.step:last-child .line {\n  display: none; /* Hide the last line */\n}\n\n\n.selectedReason,.selectedPractice{\n    color: white;\n    font-weight: bold;\n    background-color: #3b82f6;\n}\n\n\n//planning\n::ng-deep .mat-step-header {\n  pointer-events: none; /* Prevents clicking on the header */\n}\n\n\n.booking-summary {\n  width: 450px;\n  margin: auto;\n}\n.booking-summary .title-col h5 {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n.summary-col {\n  width: 100%;\n  mat-card {\n    border-radius: 4px;\n    font-weight: 700;\n  }\n}\n.summary-col + .summary-col {\n  padding-top: 16px;\n}\n.summary-col-inner {\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0px 6px 15px #00000014;\n  display: inline-block;\n  width: 100%;\n  padding: 15px;\n}\n.summary-col-inner > div + div {\n  padding-top: 10px;\n}\n.summary-col-inner span {\n  float: right;\n  color: #858585;\n}\n::ng-deep .app.blue .mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field.mat-mdc-form-field .mdc-notched-outline__notch{\n  border-right: 1px solid transparent !important;\n}\n\n::ng-deep .mat-mdc-floating-label{\n  font-family: \"Montserrat\";\n}\n::ng-deep .mat-mdc-unelevated-button>.mat-icon,\n::ng-deep .mat-mdc-raised-button>.mat-icon,\n::ng-deep .mat-mdc-outlined-button>.mat-icon{\n  margin:0 !important;\n}\n\n::ng-deep .mat-horizontal-content-container {\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
